<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
                btnTitle="List"
                :showBtn="true"
                :showAddNew="false"
                title="Create Quotation"
                @onClickCloseButton="onClickCloseButton"
            />
        </div>

        <div class="row p-1">
            <div class="col-md-3">
                <label class="form-label">Order Date</label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="date"
                    placeholder=""
                    v-model="formData.date"
                >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="form-label"> Customer Name </label>
                <AsyncSelect
                    placeholder="Select Customer"
                    v-model="contactProfile"
                    :api-service="fetchContactProfiles"
                />
            </div>

            <div class="col-md-3">
                <label class="form-label"> Project </label>
                <AsyncSelect
                    placeholder="Select Customer"
                    v-model="project"
                    :api-service="fetchProjects"
                />
            </div>

            <div class="col-md-3">
                <label class="form-label"> Business Unit </label>
                <v-select
                    placeholder="Select Business"
                    v-model="formData.business_id"
                    :options="businessList"
                    label="name"
                    :reduce="name => name.id"
                />
            </div>

            <div class="col-md-3">
                <label class="form-label"> Deal No </label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="text"
                    placeholder=""
                    v-model="formData.deal_no"
                    readonly
                >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="form-label"> Client Owner </label>
                <AsyncSelect
                    placeholder="Select Customer"
                    v-model="clientOwner"
                    :api-service="fetchContactProfiles"
                />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="form-label"> Sales Person </label>
                <AsyncSelect
                    placeholder="Select Customer"
                    v-model="salesPerson"
                    :api-service="fetchContactProfiles"
                />
            </div>

            <div class="col-md-3">
                <label class="form-label"> Validate Till Date </label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="date"
                    placeholder=""
                    v-model="formData.expiry_date"
                >
            </div>
        </div>

        <div>
            <AddItem 
                v-for="(data, index) in itemsDetails"
                :key="index"
                :index="index"
                :data="data"
                :vatRate="vatRate"
                @onClose="removeBill"
            />
        </div>

        
        <div class="px-2 mt-2">
            <button @click="addNewBill" class="btn btn-primary">Add line</button>
        </div>

        <div class="px-2">
            <div class="row justify-content-end">
                <div class="col-12 col-sm-3">
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Sub total</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model="subTotal"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">VAT</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model="totalVAT"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Total</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model="total"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Discount / Round up Adj</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model.trim="adjustmentDiscount"
                                        type="number"
                                        class="form-control form-control-sm discount-adj ml-auto text-right"
                                        placeholder="amount" :min="0"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Net Bill</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model.trim="grandTotal"
                                        type="number" class="form-control form-control-sm discount-adj ml-auto text-right"
                                        placeholder="amount" :min="0"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 px-2">
            <div class="mb-1">
                <label class="form-label" for="description"> Terms And Conditions </label>
                <vField
                    as="textarea"
                    name="description"
                    type="number"
                    class="form-control"
                    v-model="formData.description"
                />
            </div>
        </div>

        <div class="pb-5 px-2 mt-4">
            <div class="d-flex flex-wrap gap-1 gy-2">
                <button :disabled="saveButtonLoader" @click="handleSubmit(true)" class="btn btn-primary">Save</button>
                <button @click="onClickCloseButton" class="btn btn-outline-secondary">Cancel</button>
            </div>
        </div>
    </div>
    
</template>

<script setup>
import { ref, onMounted, computed, inject } from 'vue';
import TitleButton from '@/components/atom/TitleButton';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from '@/services/modules/contact';
import handleProjects from "@/services/modules/procurement/project";
import handleCBusinesses from '@/services/modules/businesses';
import AddItem from '@/components/molecule/company/admin/quotation/AddItem.vue';
import handleAdmin from '@/services/modules/admin/admin';
import { useRouter, useRoute } from 'vue-router';
import { vatRate } from '@/data/inventory.js'

const { fetchContactProfiles } = handleContact();
const { fetchProjects } = handleProjects();
const { fetchBusinessList } = handleCBusinesses();
const { storeQuotation } = handleAdmin();

const router = useRouter();
const route = useRoute();

const contactProfile = ref(null);
const project = ref(null);
const businessList = ref([]);
const clientOwner = ref(null);
const salesPerson = ref(null);
const adjustmentDiscount = ref(0);
const saveButtonLoader=ref(false);
const showSuccess = inject('showSuccess');

const formData = ref({
    date: new Date().toISOString().split('T')[0],
    contact_profile_id: null,
    referrer_id: null,
    sales_person_id: null,
    project_id: null,
    business_id: null,
    deal_no: null,
    expiry_date: new Date().toISOString().split('T')[0],
    adjustment_amount: null,
    has_item_detail: true,
    item_details: [
        {
            product_id: null,
            quantity: 1,
            free_quantity: 0,
            rate: '',
            vat: 0,
            vat_amount: 0,
            description: "",
            discount_amount: 0,
            offer_discount: 0,
            discount_percent: 0,
        }
    ],
});

const itemsDetails = computed(() => {
    return formData.value.item_details
});

const companyId = computed(() => {
    return route.params.companyId
})

const subTotal = computed(() => {
    let subTotal = 0

    formData.value.item_details.map(item => {
        subTotal += parseFloat((item.quantity * item.rate) - item.discount_amount - item.offer_discount)
    })

    return subTotal.toFixed(4);
})

const totalVAT = computed(() => {
    let vat = 0
    formData.value.item_details.map(item => {
        if(item.vat_amount) {
            vat += parseFloat(item.vat_amount)
        }
    })

    return vat.toFixed(2)
})

const total = computed(() => {
    return (parseFloat(subTotal.value) + parseFloat(totalVAT.value)).toFixed(4);
})

const grandTotal = computed(() => {
    return ((parseFloat(total.value) - adjustmentDiscount.value).toFixed(2));
})

//Methods:
const handleSubmit = async () => {
    saveButtonLoader.value = true;
    formData.value.company_id = route.params.companyId;
    formData.value.adjustment_amount = adjustmentDiscount.value;

    if(contactProfile.value) {
        formData.value.contact_profile_id = contactProfile.value.id;
    }
    
    if(clientOwner.value) {
        formData.value.referrer_id = clientOwner.value.id;
    }

    if(salesPerson.value) {
        formData.value.sales_person_id = salesPerson.value.id;
    }
    
    if(project.value) {
        formData.value.project_id = project.value.id;
    }
    
    try {
        const res = await storeQuotation(formData.value);
        if (!res.status) {
            return showError(res.message);
        }
        showSuccess(res.message);
        onClickCloseButton();
        saveButtonLoader.value = false;
    } catch (err) {
        console.error(err);
    }
}

const addNewBill = () => {
    formData.value.item_details.push({
        product_id: null,
        quantity: 1,
        rate: '',
        vat: 0,
        vat_amount: 0,
        description: '',
        discount_amount: 0,
        offer_discount: 0,
        discount_percent: 0,
        business_id: null,
        project_id: null,
        cost_centre_id: null
    })
}

const removeBill = (index) => {
    formData.value.item_details.splice(index, 1)
}

const onClickCloseButton = () => {
    router.push({
      name: 'quotation-list',
      params: route.params,
      query: route.query
    })
}

onMounted(() => {
    const companyQuery = `?company_id=${companyId.value}`;

    const businessRes = fetchBusinessList(companyQuery)

    Promise.all([
        businessRes.then(res=> {
            if(res.data) businessList.value = res.data
        }),
    ])
})
</script>